import Cookies from 'js-cookie'

const ACCESS_TOKEN_KEY = 'access_token'

export function getAccessToken () {
  return Cookies.get(ACCESS_TOKEN_KEY)
}

export function setAccessToken (accessToken) {
  Cookies.set(ACCESS_TOKEN_KEY, accessToken)
}

export function removeAccessToken () {
  Cookies.remove(ACCESS_TOKEN_KEY)
}



// WEBPACK FOOTER //
// ./src/store/common/token.js